<template>
    <section class="bg-[#f6f6f6]  flex items-center justify-center px-4 py-12">
      <div class="bg-white max-w-5xl w-full p-20 -mt-40 rounded shadow-md">

        <p class="text-center text-gray-500 mb-8">PARABÉNS, SUA ASSINATURA FOI REALIZADA COM SUCESSO!</p>
        <h1 class="text-3xl font-bold text-center text-gray-800 mb-2">PEDIDO EM PROCESSAMENTO... AGUARDE!</h1>
       
  
        <div class="text-gray-800 space-y-4 text-sm leading-relaxed">
          <p>
  <br>
  Você acaba de se tornar um cliente <strong>Integrator Host do Brasil</strong>. É um prazer ter você conosco!
</p>

<div class="bg-red-100 border border-red-400 text-red-800 p-6 rounded-md text-sm leading-relaxed space-y-2">
  <p class="font-bold">IMPORTANTE:</p>
  <p><span class="underline">A entrega dos dados de acesso varia conforme o tipo de plano contratado:</span></p>

  <ul class="list-disc pl-5 space-y-1">
    <li><strong>Planos VPS e Dedicado:</strong> os dados de acesso serão enviados <strong>somente após a confirmação do pagamento</strong>.</li>
    <li><strong>Demais planos:</strong> os dados de acesso serão enviados em até <strong>2 horas</strong> após a contratação.</li>
  </ul>

  <p>O e-mail será enviado com o assunto: <strong>"Configurações e Instruções de Uso"</strong>.</p>
  <p>Por favor, aguarde o envio das informações e <strong>evite fazer múltiplas solicitações</strong> durante esse período.</p>
</div>

<p>
  <strong>Atenção:</strong> o e-mail com os dados de acesso pode ser classificado como <strong>SPAM ou lixo eletrônico</strong> por alguns provedores. Recomendamos que verifique essas pastas e adicione nossos endereços à sua lista de contatos confiáveis:
</p>

<ul class="pl-4">
  <li><strong>integrator@integrator.host</strong></li>
  <li><strong>cobranca@integrator.com.br</strong></li>
</ul>

<p class="mt-4 font-semibold">Resumo da sua compra:</p>
<ul class="pl-4">
  <li><strong>ID da Assinatura:</strong> <span id="id">{{ assinaturaId }}</span></li>
  <li><strong>Valor:</strong> <span id="valor">R$ {{ formatarReal(valor) }}</span></li>
</ul>

<p class="mt-4 font-semibold">Seus dados de contato:</p>
<ul class="pl-4">
  <li><strong>E-mail:</strong> {{ email }}</li>
  <li><strong>WhatsApp/Celular:</strong> {{ telefone }}</li>
</ul>

<p class="mt-4">
  <strong>Em caso de dúvidas ou se não receber os dados de acesso, entre em contato conosco por um dos canais abaixo:</strong>
</p>

<ul class="text-sm pl-0 space-y-1">
  <li>WhatsApp: +55 (11) 94589.5095</li>
  <li>Site: <a href="https://www.integrator.com.br">https://www.integrator.com.br</a></li>
  <li>Instagram: <a href="https://instagram.com/integratorhost">@integratorhost</a></li>
  <li>Facebook: <a href="https://www.facebook.com/IntegratorHost">/IntegratorHost</a></li>
  <li>Youtube: <a href="https://www.youtube.com/@integratorhost">/@integratorhost</a></li>
</ul>

<p class="mt-4">
  Atenciosamente,<br />
  <strong>Equipe Integrator Host do Brasil</strong>
</p>


        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { useRoute } from 'vue-router'
  
  const route = useRoute()
  
  const assinaturaId = route.query.id || '-'
  const email = route.query.email || '-'
  const valor = route.query.valor || '0,00'
  const telefone = route.query.telefone || '-'
  
  function formatarReal(valor) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(parseFloat(valor))
  }
  </script>
  
  <style scoped>
  ul {
    list-style: disc;
    padding-left: 1.25rem;
  }
  </style>
  